import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import every from 'lodash/every';
import get from 'lodash/get';
import { compose, withHandlers, withProps } from 'recompose';
import ServicesTable from '../components/ServicesTable';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import { withFormName } from '../../../../common/hoc/withFormName';

export default compose(
  withLoadingList(
    props => props.services,
    () => null,
  ),
  withFormName,
  connect((state, props) => ({
    formValues: getFormValues(props.form)(state),
  }), { changeField: change }),
  withProps(props => ({
    allSelected: every(props.services, service => get(props.formValues, ['services', service.id])),
  })),
  withHandlers({
    setAllSelected: props => (value) => {
      props.services.forEach((service) => {
        if (get(props.formValues, ['services', service.id]) === value) {
          return;
        }

        props.changeField(props.form, `services.${service.id}`, value);
      });
    },
  }),
)(ServicesTable);
